export default {
  admin: '1',
  manufacturer: '2',
  installer: '3',
  enduser: '4',
  service: '5',
};



// WEBPACK FOOTER //
// ./src/constants/roles.js